<template>
    <outboxCon :bg="bg">
        <div class="support-teacher">
            <app-title :main='main' :sub='sub'></app-title>
            <div class="support-box">
                <img v-if="showBg" class="icon-bg" src="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/images/product/support-bg.png">
                <div class="support-item" :class="{ 'support-warp': warpNum && ((index +1) % warpNum === 0) }" v-for="(item, index) in supportList" :key="`support${index}`">
                    <img class="des-img" :src="item.url" :style="{ width: `${imgW}px`, heigt: `${imgH}px`}">
                    <div class="des-info" :style="{width: `${imgW}px`, height: `${desH}px`}">
                        <p class="main">{{item.main}}</p>
                        <p v-if="item.des" class="des">{{item.des}}</p>
                    </div>
                </div>
            </div>
        </div>
    </outboxCon>
</template>
<script>
import methosScroll from './hashScroll/methodScroll'
export default {
  props: {
    teacherUrl: {
      type: String,
      default: ''
    },
    bg: {
      type: String,
      default: ''
    },
    main: {
      type: String,
      default: ''
    },
    sub: {
      type: String,
      default: ''
    },
    showBg: {
      type: Boolean,
      default: false
    },
    configList: {
      type: Array,
      default: () => []
    },
    desH: {
      type: Number,
      default: 100
    },
    imgW: {
      type: Number,
      default: 356
    },
    imgH: {
      type: Number,
      default: 278
    },
    warpNum: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      supportList: this.configList
    }
  },
  components: { methosScroll }
}
</script>
<style lang="scss" scoped>
    .support-teacher{
        width: $main-width;
        margin: 0 auto;
        padding: 50px 0px 95px 0px;
        position: relative;
        .support-box{
            position: relative;
            margin-top: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .icon-bg{
                position: absolute;
                width: 531px;
                height: 456px;
                left: 491px;
                top: -2px;
                z-index: 0;
            }
            .support-item{
                margin-top: 10px;
                margin-right: 20px;
                position: relative;
                z-index: 1;
                border-radius: 4px;
                overflow: hidden;
                box-shadow: 0px 10px 24px 0px rgba(147, 147, 147, 0.14);
                .des-info{
                    width:356px;
                    height: 100px;
                    background:rgba(255,255,255,1);
                    padding: 20px;
                    text-align: left;
                    .main{
                        font-size:20px;
                        font-family:PingFangSC-Medium;
                        line-height:28px;
                        text-shadow:0px 10px 24px rgba(147,147,147,0.14);
                    }
                    .des{
                        margin-top: 10px;
                        font-size:16px;
                        font-family:PingFangSC-Regular;
                        line-height:22px;
                        text-shadow:0px 10px 24px rgba(147,147,147,0.14);
                    }
                }
                &:last-of-type{
                    margin-right: 0px;
                }
                &.support-warp{
                  margin-right: -20px;
                }
            }
        }
    }
</style>
